import * as React from "react";
import styled from "styled-components";
import { select, useSelect } from "@hubper/theme";
import { useSpring, animated } from "react-spring";

import { Check } from "styled-icons/material/Check";
import { Minus } from "styled-icons/boxicons-regular/Minus";

// @ts-ignore
// tslint:disable-next-line:no-empty
function nope() {}

const SIZE = 16;

const Base = styled(animated.div)`
  width: ${SIZE}px;
  height: ${SIZE}px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-width: 1px;
  border-style: solid;
  border-radius: ${select.radius("light")};
  cursor: pointer;
`;

type Props = {
  value?: boolean;
  partial?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
};

function Checkbox(
  { style, value, partial, onClick, className }: Props,
  ref: any
) {
  const { color } = useSelect();
  const [isOver, setOver] = React.useState(false);

  const outerProps = useSpring({
    backgroundColor: value || partial ? color(["primary", 4]) : "white",
    borderColor:
      value || partial
        ? "rgba(255,255,255, 0)"
        : color(["grey", isOver ? 4 : 2]),
    color: isOver && !value && !partial ? color(["primary", 1]) : "white",
    config: {
      tension: 400,
      mass: 1,
      friction: 30
    }
  });

  const innerProps = useSpring({
    transform: `scale(${value || (isOver && !value) ? 1 : 0})`,
    config: {
      tension: 400,
      mass: 1,
      friction: 20
    }
  });

  return (
    <Base
      data-testid="checkbox"
      className={className}
      ref={ref}
      onClick={onClick || nope}
      onMouseEnter={() => setOver(true)}
      onMouseLeave={() => setOver(false)}
      style={{
        ...outerProps,
        ...style
      }}
    >
      {partial && (
        <Minus
          style={{
            ...innerProps,
            filter: partial ? "drop-shadow(1px 1px 3px rgba(0,0,0,0.1))" : ""
          }}
          size={16}
        />
      )}
      {value && (
        <Check
          data-testid="checkbox-check"
          style={{
            ...innerProps,
            filter: value ? "drop-shadow(1px 1px 3px rgba(0,0,0,0.1))" : ""
          }}
          size={16}
        />
      )}
    </Base>
  );
}

export default React.forwardRef(Checkbox);
